import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import messages from '../readinessMessages';
import { profileName } from '../readinessNames';
import CustomerList from './CustomerList';
import ReadinessGroup from './ReadinessGroup';
// Grouped per user: one employee who left usually still sits on many customer files.
const UsersSection = ({ issues, checkedCount }) => {
    const intl = useIntl();
    const groups = useMemo(() => {
        const byUser = new Map();
        issues.forEach(issue => {
            const assignmentsByUser = new Map();
            issue.invalidUsers.forEach(user => {
                var _a;
                const role = profileName(intl, user.profile);
                const assignment = user.employeeName
                    ? intl.formatMessage(messages.InactiveUser, { role, name: user.employeeName })
                    : intl.formatMessage(messages.UnknownUser, { role });
                assignmentsByUser.set(user.userId, [
                    ...((_a = assignmentsByUser.get(user.userId)) !== null && _a !== void 0 ? _a : []),
                    assignment,
                ]);
                if (!byUser.has(user.userId))
                    byUser.set(user.userId, { userId: user.userId, name: user.employeeName, rows: [] });
            });
            assignmentsByUser.forEach((assignments, userId) => {
                var _a;
                return (_a = byUser.get(userId)) === null || _a === void 0 ? void 0 : _a.rows.push({
                    key: `${issue.relationId}|${userId}`,
                    relationId: issue.relationId,
                    relationName: issue.relationName,
                    detail: assignments.join(', '),
                });
            });
        });
        return [...byUser.values()].sort((a, b) => b.rows.length - a.rows.length);
    }, [issues, intl]);
    if (checkedCount === 0)
        return _jsx("p", Object.assign({ className: "text-muted" }, { children: intl.formatMessage(messages.NoRelationsWithUsers) }));
    if (issues.length === 0)
        return (_jsx("p", Object.assign({ className: "readiness-all-ok" }, { children: intl.formatMessage(messages.AllAssignedUsersActive) })));
    return (_jsx(_Fragment, { children: groups.map(group => {
            var _a;
            return (_jsx(ReadinessGroup, Object.assign({ title: (_a = group.name) !== null && _a !== void 0 ? _a : intl.formatMessage(messages.UnknownUserName), detail: group.name ? intl.formatMessage(messages.NoLongerActive) : '', count: intl.formatMessage(messages.Customers, { count: group.rows.length }), action: null }, { children: _jsx(CustomerList, { detailHeader: intl.formatMessage(messages.ColInvalidAssignment), rows: group.rows.slice().sort((a, b) => a.relationName.localeCompare(b.relationName)) }) }), group.userId));
        }) }));
};
export default UsersSection;
